import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Images from "../images";
import LazyImg from "./LazyImg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Link, useOutletContext } from "react-router-dom";

import SignIn from "./SignIn";
import { Navigation } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import { useLocation } from "react-router-dom";
import axiosInstance from "../Help/AxiosLogicInstance";
import { toast } from "react-toastify";
import "./ApplicationBanner.css";
const LaboratoryTour = () => {
  const navigate = useNavigate();
  const [formSource, setFormSource] = useState("");
  const location = useLocation();
  const token = localStorage.getItem("token");
  const prevRef = useRef(null);
  const { setActiveModal } = useOutletContext();
  const nextRef = useRef(null);
  const [swiperReady, setSwiperReady] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);
  const [isFormActive, setIsFormActive] = useState(false);
  
  useEffect(() => {
    // Delay enabling navigation until refs exist
    setSwiperReady(true);
  }, []);
  
  // Check if the form is active
  useEffect(() => {
    const checkFormStatus = async () => {
      try {
        const response = await axiosInstance.get('/api/Student/GetApplicationSettingMasterByFormId/3');
        if (response.data && 
            response.data.Status === "200" && 
            response.data.Data && 
            response.data.Data.length > 0) {
          setIsFormActive(response.data.Data[0].IsActive);
        } else {
          setIsFormActive(false);
        }
      } catch (error) {
        console.error("Error fetching form status:", error);
        setIsFormActive(false);
      }
    };
    
    checkFormStatus();
  }, []);

  const [hoveredCard, setHoveredCard] = useState(null);

  const contacts = [
    {
      id: 1,
      title: "Registration & Application",
      email: "application@med-engage.com",
      gradient: "lightblue",
      icon: "📋",
      description: "Start your medical journey with us",
    },
    {
      id: 2,
      title: "Support & Contact",
      email: "support@med-engage.com",
      gradient: "lightgreen",
      icon: "🚀",
      description: "Get help when you need it",
    },
    {
      id: 3,
      title: "Academics",
      email: "academics.sciencecell@metropolisindia.com",
      gradient: "lightpink",
      icon: "🎯",
      description: "Academic excellence support",
    },
  ];

  const teamMembers = [
    {
      id: 1,
      name: "Shalini Sahay",
      email: "shalini.sahay@metropolisindia.com",
      phone: "+91 9310554590",
      gradient: "lightcoral",
      avatar: "SS",
      role: "Team Lead",
    },
    {
      id: 2,
      name: "Jeyasingh B",
      email: "jeyasingh.b@metropolisindia.com",
      phone: "+91 8928286168",
      gradient: "lightseagreen",
      avatar: "JB",
      role: "Secondary Contact",
    },
  ];
  const faqs = [
    {
      question:
        "Which areas and activities will be included during the Laboratory Tour, and can it be customized ?",
      answer:
        "The visiting team can avail the accessibility of Laboratory tour across India at 125 + locations at their chosen location in above-mentioned department. If required, the laboratory tour can be customized as per the request of the visiting team.",
    },
    {
      question:
        "  Is there a way for participants to receive official certificates or acknowledgment after completing the Laboratory tour ?",
      answer:
        "There is no cost attached to the  Laboratory tour. However, travel to the Laboratory site in the specific geography would have to be borne by the visiting team.",
    },
    {
      question:
        "Post attending the Laboratory tour can visiting individuals or Institutes get any other additional support ?",
      answer: (
        <>
          Metropolis is open to support provided the required support is
          specific. If the applicant or visiting doctor is interested in
          exploring more opportunities, they can also apply for Observership by
          clicking the link below for Observership opportunity. Please visit the
          website of MedEngage:{" "}
          <a
            href="https://www.med-engage.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.med-engage.com
          </a>{" "}
          to know more about Laboratory Tour. The time for observership ranges
          from 5-15 days.
        </>
      ),
    },
    {
      question:
        " Are participants eligible to receive certificates or official acknowledgment after completing the Laboratory tour ?",
      answer:
        "There is no provision of certificates post Laboratory tour but each visiting team will receive a testimonial from Metropolis Healthcare limited after submitting the feedback form of the Laboratory tour.",
    },
    {
      question: "Where are 200 laboratories located ?",
      answer: (
        <>
          Please visit the google map to locate the nearest Metropolis
          healthcare Laboratory for your visit. To apply for Laboratory tour,
          please visit the MedEngage website and apply online:{" "}
          <a
            href="https://www.med-engage.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.med-engage.com
          </a>{" "}
          Click here to locate labs. You may also write to us at
          support@med-engage.com
        </>
      ),
    },
    {
      question:
        "Are there any prerequisites before attending the Laboratory tour?",
      answer:
        "Carry a valid ID and follow basic lab safety protocols. Wear appropriate attire and follow staff instructions.",
    },
  ];
  const [loading, setLoading] = useState(true);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const carouselImages = [
    {
      src: Images.labTour1,
    },
    {
      src: Images.labTour2,
    },
    {
      src: Images.labTour3,
    },
    {
      src: Images.labTour4,
    },
    {
      src: Images.labTour5,
    },
    {
      src: Images.labTour6,
    },
    {
      src: Images.labTour7,
    },
    {
      src: Images.labTour8,
    },
    {
      src: Images.labTour9,
    },
  ];
  useEffect(() => {
    document.title = "Laboratory Tour - MedEngage";
  }, []);

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}
      <div>
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">Laboratory Tour</h2>
            <ul className="ul-breadcrumb-nav">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <span className="separator">
                 <i className="fa fa-arrow-right"></i>
                </span>
              </li>
              <li>Laboratory Tour</li>
            </ul>
          </div>
        </section>

        <section className="ul-about ul-section-spacing ">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
              <div className="col">
                <div className="ul-about-txt">
                  <h2 className="ul-section-title">
                    Laboratory{" "}
                    <span>
                      <strong className="green"> Tour</strong>
                    </span>
                  </h2>

                  <p className="ul-section-descr">
                    Under the CSR initiative, a Laboratory tour is an important
                    activity of the MedEngage programme. A Laboratory tour
                    serves as expanding the learning horizons and helping the
                    participants to ignite their minds.
                  </p>
                  <p className="ul-section-descr">
                    The Laboratory tours are meant for doctors, health care
                    professionals, consultants, super specialists, and medical
                    students. The main objective of the Laboratory tour is to
                    give exposure to the high-end world-class Laboratories which
                    serve as experiential learning.
                  </p>
                  <p className="ul-section-descr">
                    The Laboratory tour component gives the visiting team an
                    idea of the services and processes followed at Metropolis
                    Healthcare Limited <strong>(‘MHL or Metropolis’)</strong>.
                  </p>
                </div>
              </div>

              <div className="col">
                <div className="ul-about-imgs">
                  <div className="img-wrapper text-center">
                    <LazyImg
                      src={Images.Tour}
                      alt="Visit to Metropolis GRL Laboratory"
                      className="scholarship-image rounded-3"
                    />
                    <div className="img-caption mt-2">
                      Visit to the Metropolis GRL Laboratory
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ul-section-spacing">
          <div className="container">
            {/*   <h2 className="text-center mb-5 fw-bold">What <span className="text-success">People say</span></h2> */}

            <div className="position-relative text-white p-4 p-md-5 student-experience bg-gradient-to-br">
              {/* Decorative circles */}
              <div className="decor-circle top-right"></div>
              <div className="decor-circle bottom-left"></div>

              <div className="position-relative z-1">
                {/* User Info */}
                <div className="d-flex align-items-center mb-3">
                  <div className="d-flex justify-content-center align-items-center rounded-3 me-3 user-icon">
                    <i className="fa fa-user  text-white fs-2"></i>
                  </div>
                  <div>
                    <h3 className="mb-0">Dr.Rajashri Kelkar</h3>
                    <p className="text-light mb-0">
                      {" "}
                      General & Breast Surgeon, Mumbai
                    </p>
                  </div>
                </div>

                {/* Quote */}
                <blockquote className="fst-italic mb-3 quote-block">
                  “MedEngage is a great outreach programme which is nuanced
                  designed to cater to the needs of the underprivileged. It is
                  great succour to the students and a great nation building
                  initiative. Dr Kelkar further mentioned that her son who is
                  joining John Hopkins university also received advice from
                  Metropolis Chief scientific officer, Dr Kirti Chadha, which
                  has helped him at every step of his career."
                </blockquote>
              </div>
            </div>
          </div>
        </section>

        {/* LAB DEPARTMENTS SECTION START */}
        <section className="ul-lab-departments ul-section-spacing bgg-light">
          <div className="container text-center">
            <h2 className="text-center mb-2 fw-bold">
              <span className="text-success">Our</span> Lab Departments
            </h2>
            <p className="ul-section-descr mb-5">
              The MedEngage program organizes tours to Metropolis Healthcare
              Limited, which has state-of-the-art facilities in over 200
              laboratories. Our Global Reference Laboratory is in Mumbai, and
              reference laboratories are in the following cities: Delhi,
              Chennai, Bengaluru, and Kolkata. During the laboratory tour,
              depending upon the city & type of MHL laboratory, the following
              departments can be visited:
            </p>

            <div className="row row-cols-2 row-cols-sm-2 row-cols-md-5 g-3 justify-content-center">
              {[
                { src: Images.Histopathology, label: "Histopathology" },
                { src: Images.Genetics, label: "Genetics" },
                { src: Images.Clinical, label: "Clinical Chemistry" },
                { src: Images.Special, label: "Special Chemistry" },
                { src: Images.Immunoassay, label: "Immunoassay" },
                { src: Images.Pathology, label: "Molecular Pathology" },
                { src: Images.RD, label: "Research & Development" },
                { src: Images.Micro, label: "Microbiology" },
                { src: Images.Molecular, label: "Molecular Biology" },
                { src: Images.Haematology, label: "Haematology" },
              ].map((dept, idx) => (
                <div
                  key={idx}
                  className="col d-flex flex-column align-items-center h-100"
                >
                  <div className="department-card bg-white rounded-4 shadow-sm p-3 mb-2 w-100 d-flex justify-content-center align-items-center">
                    <LazyImg
                      src={dept.src}
                      alt={dept.label}
                      className="img-fluid rounded"
                    />
                  </div>
                  <p
                    className="semi fw-bold text-center mt-auto"
                    style={{ minHeight: "2rem" }}
                  >
                    {dept.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* LAB DEPARTMENTS SECTION END */}
        <section className="ul-about ul-section-spacing">
          <div className="ul-container application-banner">
            <div className="row align-items-center">
              {/* Left Illustration */}
              <div className="col-md-6 mb-3 mb-md-0 text-center text-md-start">
                <LazyImg
                  src={Images.labTourVector}
                  alt="Laboratory tour illustration"
                  className="img-fluid"
                />
              </div>

              {/* Right Text */}
              <div className="col-md-6 banner-text text-center text-md-start">
                <h2 className="mb-2 fw-bold">Laboratory Tour Application</h2>
                <p className="mb-3">
                  Apply now and take your first step to success.
                </p>

                <div className="d-flex flex-column flex-sm-row align-items-center gap-2 justify-content-center justify-content-md-start">
                  {isFormActive ? (
                    token ? (
                      <button
                        className="btn-login btn-lg"
                        onClick={() => navigate("/laboratory-tour-application/")}
                      >
                        Apply
                      </button>
                    ) : (
                      <button
                        className="btn-login d-flex align-items-center gap-2"
                        onClick={() => {
                          if (token) navigate("/laboratory-tour-application/");
                          else setActiveModal("signIn"); // opens SignIn modal
                        }}
                      >
                        Login
                      </button>
                    )
                  ) : (
                    <div className="alert alert-info mb-0">
                      Applications are currently closed. Please check back later.
                    </div>
                  )}

                  {showSignIn && (
                    <SignIn
                      show={showSignIn}
                      handleClose={() => setShowSignIn(false)}
                      from={formSource}
                    />
                  )}

                  <LazyImg
                    src={Images.Arrow}
                    alt="decorative arrow"
                    className="img-fluid ms-5 arrow-image  d-none d-lg-inline-block"
                    style={{ transform: "rotate(70deg)" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ul-about">
          <div>
            <h2 className="text-center mb-5 fw-bold">
              Glimpses of{" "}
              <span className="text-success">Laboratories of MHL</span>
            </h2>

            {swiperReady && (
              <Swiper
                modules={[Navigation, Autoplay]}
                slidesPerView={3} // default for desktop
                spaceBetween={80} // default spacing
                loop={true}
                centeredSlides={true}
                freeMode={true}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                }}
                breakpoints={{
                  320: {
                    // mobile
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  576: {
                    // small tablet
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  992: {
                    // desktop
                    slidesPerView: 3,
                    spaceBetween: 80,
                  },
                }}
              >
                {carouselImages.map((item, index) => (
                  <SwiperSlide key={index} className="slide">
                    <div className="slide-content">
                      <div className="image-wrapper">
                        <LazyImg
                          src={item.src}
                          alt={`Laboratory image ${index + 1}`}
                          className="slide-image rounded shadow-sm"
                        />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}

            {/* Custom Buttons */}
            <div className="d-flex justify-content-center align-items-center mt-4 gap-3">
              <button
                ref={prevRef}
                className="btn btn-success rounded-circle btn-carousel cor-btn"
                type="button"
              >
                &#8592;
              </button>
              <button
                ref={nextRef}
                className="btn btn-success rounded-circle btn-carousel cor-btn"
                type="button"
              >
                &#8594;
              </button>
            </div>
          </div>
        </section>

        <section className="faq-section">
          <div className="ul-container">
            <h2 className="ul-section-title text-center p-2 m-2">FAQs</h2>
            <div className="faq-container">
              <div className="faq-grid">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="faq-item"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div style={{ flex: 1 }}>
                      <span className="faq-question">{faq.question}</span>
                      <div
                        className={`faq-answer ${
                          openIndex === index ? "show" : ""
                        }`}
                        onClick={(e) => e.stopPropagation()} // prevents closing when clicking inside
                      >
                        {faq.answer}
                      </div>
                    </div>
                    <span className="faq-icon">
                      <img
                        src={openIndex === index ? Images.Minus : Images.Plus}
                        alt={openIndex === index ? "Minus" : "Plus"}
                      />
                    </span>
                  </div>
                ))}
              </div>
              {/*   <div className="text-center mt-4">
            <button className="btn-view">View All</button>
          </div> */}
            </div>
          </div>
        </section>

        <section className="med-cards-section py-4 py-md-5">
          <div className="container-fluid px-3 px-md-5">
            {/* Department Contacts */}
            <div className="row g-2 g-md-2 mb-3 mb-md-5 justify-content-center">
              <div className="col-12 text-center mb-1 mb-md-4">
                <h2 className="fw-bold">
                  <span className="text-success">Contact</span> Information
                </h2>
                <div className="divider mx-auto"></div>
              </div>
              {contacts.map((contact, index) => (
                <div
                  key={contact.id}
                  className="col-12 col-sm-6 col-lg-4 d-flex"
                >
                  <div
                    className="contact-card department-card flex-fill"
                    onMouseEnter={() => setHoveredCard(`dept-${contact.id}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="contact-card-content text-center p-2 h-100 d-flex flex-column justify-content-between">
                      <div
                        className="icon-container"
                        style={{ background: contact.gradient }}
                      >
                        <span className="icon-emoji">{contact.icon}</span>
                        <div className="pulse-ring"></div>
                      </div>

                      <h6 className="card-title mb-2">{contact.title}</h6>
                      <p className="card-description text-muted">
                        {contact.description}
                      </p>

                      <div className="email-container">
                        <a
                          href={`mailto:${contact.email}`}
                          className="email text-success"
                          title={contact.email}
                        >
                          {contact.email}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Team Members */}
            <div className="row g-2 g-md-2 justify-content-center">
              <div className="col-12 text-center mb-1 mb-md-3">
                <div className="divider mx-auto"></div>
              </div>

              {teamMembers.map((member, index) => (
                <div
                  key={member.id}
                  className="col-12 col-sm-6 col-lg-4 d-flex"
                >
                  <div
                    className="contact-card team-card flex-fill"
                    onMouseEnter={() => setHoveredCard(`team-${member.id}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{ animationDelay: `${(index + 3) * 0.1}s` }}
                  >
                    <div className="card-content text-center p-2 h-100 d-flex flex-column justify-content-between">
                      <div
                        className="avatar-container"
                        style={{ background: member.gradient }}
                      >
                        <span className="avatar-text">{member.avatar}</span>
                        <div className="avatar-ring"></div>
                      </div>

                      <h4 className="member-name mb-2">{member.name}</h4>

                      <div className="contact-info d-flex flex-column gap-1 w-100">
                        <div className="email-container">
                          <a
                            href={`mailto:${member.email}`}
                            className="email text-success"
                          >
                            {member.email}
                          </a>
                        </div>
                        {member.phone && (
                        <div className="email-container">
                          <a
                            href={`tel:${member.phone}`}
                            className="email text-dark"
                          >
                            {member.phone}
                          </a>
                        </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LaboratoryTour;
